// VitaminsCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { VITAMINS } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function VitaminsCard() {
  const { t } = useTranslation();

  const panel = {
    id: "vitamins",
    title: t("card_vitamins_title"),
    subtitle: t("card_vitamins_desc"),
    biomarkers: t("card_vitamins_markers"),
    price: "€ 419",
    image: VITAMINS,
  };

  return <BasePackageCard panel={panel} />;
}